import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare, ArrowRight, Calculator } from 'lucide-react';

interface DemoInterstitialProps {
  onStartDemo: () => void;
  onGetAssistant: () => void;
}

const DemoInterstitial: React.FC<DemoInterstitialProps> = ({ onStartDemo, onGetAssistant }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-teal/10 rounded-full mb-6">
        <Calculator className="h-8 w-8 text-brand-teal" />
      </div>
      
      <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
        Live Accounting Assistant – Demo
      </h2>
      
      <div className="max-w-lg text-muted-foreground space-y-4 mb-8">
        <p>
          This is a governed AI assistant designed to explain New Zealand accounting and tax concepts 
          using authoritative public sources.
        </p>
        <p>
          It provides general information only and does not offer personalised advice or calculations.
        </p>
        <p className="text-sm text-muted-foreground/80 italic">
          This is the same assistant your firm would deploy, shown here without firm-specific customisation.
        </p>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Button 
          size="lg" 
          onClick={onStartDemo}
          className="bg-brand-teal hover:bg-brand-teal/90"
        >
          <MessageSquare className="mr-2 h-5 w-5" />
          Start Demo
        </Button>
        
        <Button 
          size="lg" 
          variant="outline"
          onClick={onGetAssistant}
        >
          Get My Assistant
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default DemoInterstitial;
